import React, { useState } from 'react';
/* eslint-disable no-unused-vars */
import { Link } from 'react-router-dom';
import './home.css';
import '../../style/global.css';
import logo from '../../images/nortesoft_extendida_2_semfundo.png';
import heroImage from '../../images/hero_image.png';
import founderImage from '../../images/Fundador.png';
import logoGoldpdv from '../../images/logo_goldpdv.png';
import logoEpdv from '../../images/logo_e-pdv.png';
import logoFoxfiscal from '../../images/Foxfiscal.png';
import Footer from '../../components/footer/footer';
import FloatingContactButton from '../../components/floatingcontact/floatingcontact';

const diferenciais = [
    {
        titulo: 'Experiência desde 2003',
        descricao:
            'Mais de duas décadas desenvolvendo e evoluindo soluções para operações comerciais, administrativas e fiscais.',
    },
    {
        titulo: 'Conhecimento da operação real',
        descricao:
            'As soluções nascem do contato direto com empresas e processos reais, não apenas de requisitos técnicos.',
    },
    {
        titulo: 'Desenvolvimento próprio',
        descricao:
            'Produtos e projetos desenvolvidos internamente, permitindo maior controle tecnológico, evolução e personalização.',
    },
    {
        titulo: 'Relacionamento de longo prazo',
        descricao:
            'Atendimento próximo, sustentação contínua e evolução das soluções acompanhando o crescimento de cada cliente.',
    },
];

const diferenciaisVisual = [
    {
        titulo: 'Experiência desde 2003',
        descricao:
            'Mais de duas décadas desenvolvendo e evoluindo soluções para operações comerciais, administrativas e fiscais.',
        tag: 'Histórico',
        icone: 'fa-clock-o',
    },
    {
        titulo: 'Conhecimento da operação real',
        descricao:
            'As soluções nascem do contato direto com empresas e processos reais, não apenas de requisitos técnicos.',
        tag: 'Método',
        icone: 'fa-line-chart',
    },
    {
        titulo: 'Desenvolvimento próprio',
        descricao:
            'Produtos e projetos desenvolvidos internamente, com mais controle tecnológico, evolução contínua e personalização.',
        tag: 'Tecnologia',
        icone: 'fa-code',
    },
    {
        titulo: 'Relacionamento de longo prazo',
        descricao:
            'Atendimento próximo, sustentação contínua e evolução das soluções acompanhando o crescimento de cada cliente.',
        tag: 'Parceria',
        icone: 'fa-handshake-o',
    },
];

const produtos = [
    {
        titulo: 'goldPDV',
        logo: logoGoldpdv,
        url: 'https://www.goldpdv.com.br',
        descricao: 'ERP desktop para automação comercial com foco em vendas, estoque, financeiro, fiscal e operação de loja.',
        funcionalidades: ['PDV e retaguarda', 'Estoque e financeiro', 'Fiscal e relatórios'],
    },
    {
        titulo: 'e-PDV',
        logo: logoEpdv,
        url: 'https://www.e-pdv.com',
        descricao: 'Loja digital com catálogo online, área administrativa, pedidos, promoções, combos e indicadores gerenciais.',
        funcionalidades: ['Loja online própria', 'Pedidos e atendimento', 'Dashboard e gestão'],
    },
    {
        titulo: 'FoxFiscal',
        logo: logoFoxfiscal,
        url: '/produtos/foxfiscal',
        interno: true,
        descricao: 'Plataforma de apoio fiscal para documentos eletrônicos, conferências tributárias e rotinas críticas da operação.',
        funcionalidades: ['Validações fiscais', 'Apoio operacional', 'Módulos em evolução'],
    },
];

const segmentos = [
    'Varejo',
    'Atacado',
    'Indústria',
    'Distribuição',
    'Food service',
    'Projetos corporativos',
];

const heroMetricas = [
    { valor: '2003', label: 'Início da Nortesoft' },
    { valor: '3', label: 'Produtos próprios em evolução' },
    { valor: 'Sob demanda', label: 'Projetos moldados ao cliente' },
];

const heroRedline = [
    {
        titulo: 'Sistemas para lojas',
        descricao: 'ERP, PDV, estoque, financeiro e emissão fiscal para uma operação completa.',
    },
    {
        titulo: 'Sites e aplicações',
        descricao: 'Presença digital profissional para posicionar a marca e gerar novas oportunidades.',
    },
    {
        titulo: 'Catálogos e cardápios digitais',
        descricao: 'Sua empresa vendendo online com experiência prática, rápida e pronta para converter.',
    },
];

const clientesParceiros = [
    { nome: 'Adua', logo: '/parceiros/ADUA.png' },
    { nome: 'Amazonnat', logo: '/parceiros/AMAZONNAT.png' },
    { nome: 'AM Tintas', logo: '/parceiros/AM_TINTAS.png' },
    { nome: 'BMS Lanches', logo: '/parceiros/bms_lanches.png' },
    { nome: 'Casa das Colunas', logo: '/parceiros/CADA_DAS_COLUNAS.png' },
    { nome: 'Casa dos Selos', logo: '/parceiros/casa_dos_selos.png' },
    { nome: 'Central de Parafusos', logo: '/parceiros/CENTRAL_DE_PARAFUSOS.png' },
    { nome: 'Central Elétrica', logo: '/parceiros/CENTRAL_ELETRICA.png' },
    { nome: 'Centro do Eletricista', logo: '/parceiros/CENTRO_DO_ELETRICISTA.png' },
    { nome: 'Costa Silva', logo: '/parceiros/COSTA_SILVA.png' },
    { nome: 'Distribuidora Javali', logo: '/parceiros/DISTRIBUIDORA_JAVALI.png' },
    { nome: 'Guarany Tintas', logo: '/parceiros/GUARANY_TINTAS.png' },
    { nome: 'HF Geradores', logo: '/parceiros/HF_GERADORES.png' },
    { nome: 'José Victhor', logo: '/parceiros/JOSE_VICTHOR.png' },
    { nome: 'K Bocão da Construção', logo: '/parceiros/kbocaodaconstrucao.png' },
    { nome: 'Manauara Telhas', logo: '/parceiros/MANAUARA_TELHAS.png' },
    { nome: 'Mário Frangos', logo: '/parceiros/MARIO_FRANGOS.png' },
    { nome: 'Nascimento Motopeças', logo: '/parceiros/NASCIMENTO_MOTOPECAS.png' },
    { nome: 'Norte Reboque', logo: '/parceiros/NORTEREBOQUE.png' },
    { nome: 'Panificadora 5P2P', logo: '/parceiros/PANIFICADORA_5P2P.png' },
    { nome: 'Panificadora Kissia', logo: '/parceiros/PANIFICADORA_KISSIA.png' },
    { nome: 'RBS Serviços', logo: '/parceiros/RBS_SERVICOS.png' },
    { nome: 'VB Express', logo: '/parceiros/VB_EXPRESS.png' },
    { nome: 'VK Materiais', logo: '/parceiros/VK_MATERIAIS.png' },
];

const capacidades = [
    'Automação de processos comerciais e industriais',
    'Emissão fiscal e controle operacional',
    'Dashboards e indicadores gerenciais',
    'Catálogos, cardápios e vendas digitais',
    'Sites institucionais e aplicações web',
    'Projetos personalizados com integração entre canais',
];

const capacidadesCards = [
    {
        titulo: 'Aplicações desktop sob demanda',
        descricao:
            'Desenvolvimento de sistemas corporativos personalizados para processos administrativos, comerciais, fiscais e operacionais.',
        icone: 'fa-desktop',
    },
    {
        titulo: 'Aplicações web corporativas',
        descricao:
            'Soluções web modernas, responsivas e integradas, desenvolvidas para gestão, operação e atendimento de empresas.',
        icone: 'fa-code',
    },
    {
        titulo: 'Sites institucionais profissionais',
        descricao:
            'Sites corporativos desenvolvidos para fortalecer a presença digital, apresentar serviços e gerar novas oportunidades de negócio.',
        icone: 'fa-globe',
    },
    {
        titulo: 'Automação comercial e administrativa',
        descricao:
            'Implantação e desenvolvimento de processos para vendas, estoque, financeiro, faturamento e gestão empresarial.',
        icone: 'fa-cogs',
    },
    {
        titulo: 'Integrações e modernização de sistemas',
        descricao:
            'Integração entre aplicações, bancos de dados, APIs e serviços em nuvem, além da evolução de sistemas já existentes.',
        icone: 'fa-exchange',
    },
    {
        titulo: 'Projetos de software sob medida',
        descricao:
            'Análise do processo de negócio e desenvolvimento de soluções específicas para necessidades que sistemas prontos não atendem.',
        icone: 'fa-rocket',
    },
];

const Home = () => {
    const [visiblePartners, setVisiblePartners] = useState(12);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    return (
        <div className="ns-home">
            <header className="ns-header">
                <div className="ns-header__top">
                    <div className="ns-header__brand">
                        <img src={logo} alt="Nortesoft Tecnologia e Automação" className="ns-header__logo" />
                    </div>

                    <button
                        type="button"
                        className={`ns-header__toggle ${mobileMenuOpen ? 'is-open' : ''}`}
                        aria-label={mobileMenuOpen ? 'Fechar menu' : 'Abrir menu'}
                        aria-expanded={mobileMenuOpen}
                        onClick={() => setMobileMenuOpen((open) => !open)}
                    >
                        <span />
                        <span />
                        <span />
                    </button>
                </div>

                <nav className={`ns-header__nav ${mobileMenuOpen ? 'is-open' : ''}`}>
                    <a href="#especialidades" onClick={() => setMobileMenuOpen(false)}>Especialidades</a>
                    <a href="#produtos" onClick={() => setMobileMenuOpen(false)}>Produtos</a>
                    <a href="#parceiros" onClick={() => setMobileMenuOpen(false)}>Clientes</a>
                    <a href="#fundador" onClick={() => setMobileMenuOpen(false)}>Fundador</a>
                    <Link to="/provisionamento" onClick={() => setMobileMenuOpen(false)}>Contato</Link>
                    <Link to="/login" className="ns-header__cta" onClick={() => setMobileMenuOpen(false)}>Entrar</Link>
                </nav>
            </header>

            <main className="ns-main">
                <section className="ns-hero">
                    <div className="ns-hero__visual">
                        <div className="ns-hero__frame">
                            <img src={heroImage} alt="Painel administrativo com indicadores de gestão" />
                            <div className="ns-hero__redline">
                                <span className="ns-hero__redline-badge">Tecnologia feita para vender</span>
                                <h2>Soluções digitais desenvolvidas para transformar, automatizar e fazer negócios crescerem.</h2>
                                <div className="ns-hero__redline-grid">
                                    {heroRedline.map((item) => (
                                        <article className="ns-hero__redline-card" key={item.titulo}>
                                            <strong>{item.titulo}</strong>
                                            <p>{item.descricao}</p>
                                        </article>
                                    ))}
                                </div>
                            </div>
                            <div className="ns-hero__metrics">
                                {heroMetricas.map((item) => (
                                    <div className="ns-hero__metric-card" key={item.label}>
                                        <strong>{item.valor}</strong>
                                        <span>{item.label}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="ns-hero__copy">
                        <span className="ns-badge">Tecnologia e automação desde 2003</span>
                        <h1>
                            A Nortesoft cria software profissional para empresas que precisam operar melhor,
                            vender mais e crescer com segurança.
                        </h1>
                        <p>
                            Somos a empresa mãe por trás do <strong>goldPDV</strong>, do <strong>e-PDV</strong> e do
                            <strong> FoxFiscal</strong>. Desenvolvemos sistemas sob demanda, automação comercial,
                            catálogos digitais, sites corporativos e aplicações que unem gestão, vendas e presença digital.
                        </p>

                        <div className="ns-hero__actions">
                            <Link to="/provisionamento" className="ns-btn ns-btn--primary">
                                Falar com a Nortesoft
                            </Link>
                            <Link to="/login" className="ns-btn ns-btn--secondary">
                                Conhecer as plataformas
                            </Link>
                        </div>

                        <div className="ns-hero__mini-panel" id="especialidades">
                            <div className="ns-hero__mini-head">
                                <span className="ns-kicker">Tecnologia desenvolvida para as necessidades do seu negócio</span>


                                <p>
                                    Desenvolvemos aplicações desktop e web, sites corporativos e soluções
                                    sob demanda, integrando tecnologia aos processos comerciais,
                                    administrativos e operacionais da sua empresa.
                                </p>
                            </div>

                            <div className="ns-hero__mini-grid">
                                {capacidadesCards.map((item) => (
                                    <article className="ns-mini-card" key={item.titulo}>
                                        <span className="ns-mini-card__icon" aria-hidden="true">
                                            <i className={`fa ${item.icone}`} />
                                        </span>
                                        <h4>{item.titulo}</h4>
                                        <p>{item.descricao}</p>
                                    </article>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>

                <section className="ns-section" id="solucoes">
                    <div className="ns-section__heading">
                        <span className="ns-kicker">Por que a Nortesoft</span>
                        <h2>Tecnologia construída com experiência, proximidade e visão de negócio</h2>
                        <p>
                            Mais do que desenvolver software, buscamos compreender a operação de cada empresa
                            para entregar soluções confiáveis, evolutivas e aderentes às necessidades reais do negócio.
                        </p>
                    </div>

                    <div className="ns-grid ns-grid--4">
                        {diferenciaisVisual.map((item) => (
                            <article className="ns-card ns-card--feature" key={item.titulo}>
                                <div className="ns-card__feature-top">
                                    <span className="ns-card__feature-icon" aria-hidden="true">
                                        <i className={`fa ${item.icone}`} />
                                    </span>
                                    <span className="ns-card__feature-tag">{item.tag}</span>
                                </div>
                                <h3>{item.titulo}</h3>
                                <p>{item.descricao}</p>
                            </article>
                        ))}
                    </div>
                </section>

                <section className="ns-section ns-section--dark" id="produtos">
                    <div className="ns-section__heading ns-section__heading--light">
                        <span className="ns-kicker">Ecossistema Nortesoft</span>
                        <h2>Produtos próprios que fortalecem gestão, vendas, fiscal e presença digital</h2>
                    </div>

                    <div className="ns-grid ns-grid--3">
                        {produtos.map((item) => (
                            item.interno ? (
                                <Link className="ns-product-card" key={item.titulo} to={item.url}>
                                    <div className="ns-product-card__logo-wrap">
                                        <img
                                            src={item.logo}
                                            alt={item.titulo}
                                            className={`ns-product-card__logo ${
                                                item.titulo === 'FoxFiscal' ? 'ns-product-card__logo--compact' : ''
                                            }`}
                                        />
                                    </div>
                                    <h3>{item.titulo}</h3>
                                    <p>{item.descricao}</p>
                                </Link>
                            ) : (
                                <a
                                    className="ns-product-card"
                                    key={item.titulo}
                                    href={item.url}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <div className="ns-product-card__logo-wrap">
                                        <img
                                            src={item.logo}
                                            alt={item.titulo}
                                            className={`ns-product-card__logo ${
                                                item.titulo === 'FoxFiscal' ? 'ns-product-card__logo--compact' : ''
                                            }`}
                                        />
                                    </div>
                                    <h3>{item.titulo}</h3>
                                    <p>{item.descricao}</p>
                                </a>
                            )
                        ))}
                    </div>
                </section>

                <section className="ns-section" id="parceiros">
                    <div className="ns-section__heading">
                        <span className="ns-kicker">Clientes e parceiros</span>
                        <h2>Empresas que confiam na execução técnica e na continuidade da Nortesoft</h2>
                        <p>
                            Nossa atuação é construída com proximidade, entendimento do negócio e capacidade de
                            transformar necessidade operacional em software profissional.
                        </p>
                    </div>

                    <div className="ns-partners-summary">
                        <article className="ns-partners-summary__card">
                            <strong>Desde 2003</strong>
                            <span>Projetos, sustentação e evolução contínua de software corporativo.</span>
                        </article>

                        <article className="ns-partners-summary__card">
                            <strong>Clientes em múltiplos segmentos</strong>
                            <span>Varejo, atacado, materiais de construção, alimentação, serviços e distribuição.</span>
                        </article>

                        <article className="ns-partners-summary__card">
                            <strong>Produtos e projetos próprios</strong>
                            <span>Ecossistema com ERP, catálogo digital, fiscal e desenvolvimento sob demanda.</span>
                        </article>
                    </div>

                    <div className="ns-grid ns-grid--partners">
                        {clientesParceiros.slice(0, visiblePartners).map((item) => (
                            <article className="ns-partner-card" key={item.nome}>
                                <div className="ns-partner-card__logo-slot">
                                    <img src={item.logo} alt={item.nome} className="ns-partner-card__logo" />
                                </div>
                                <span className="ns-partner-card__name">{item.nome}</span>
                            </article>
                        ))}
                    </div>

                    {visiblePartners < clientesParceiros.length ? (
                        <div className="ns-partners-more">
                            <button
                                type="button"
                                className="ns-btn ns-btn--secondary ns-btn--inline"
                                onClick={() => setVisiblePartners((current) => current + 8)}
                            >
                                Mostrar mais parceiros
                            </button>
                        </div>
                    ) : null}
                </section>

                <section className="ns-section" id="fundador">
                    <div className="ns-founder">
                        <div className="ns-founder__photo">
                            <img src={founderImage} alt="Karlo Uchôa - Fundador da Nortesoft" />
                        </div>

                        <div className="ns-founder__content">
                            <span className="ns-kicker">Fundador</span>
                            <h2>Karlo Uchôa</h2>

                            <p>
                                Especialista em Redes de Computadores e Bancos de Dados Relacionais,
                                atua no desenvolvimento de software e aplicações
                                corporativas desde 2003. É fundador da Nortesoft e responsável pela
                                concepção e evolução de soluções voltadas à automação comercial,
                                gestão empresarial, tecnologia fiscal e transformação digital.
                            </p>

                            <p>
                                Ao longo de sua trajetória, vem combinando experiência prática em
                                tecnologia e conhecimento dos processos reais das empresas para
                                desenvolver sistemas como o <strong>goldPDV</strong>, o
                                <strong> FoxFiscal</strong> e, mais recentemente, o
                                <strong> e-PDV</strong>, ampliando a atuação da Nortesoft para
                                aplicações web, serviços em nuvem e novos modelos de operação digital.
                            </p>

                            <p>
                                Atualmente cursa Ciência da Computação e mantém seus estudos voltados
                                à Engenharia de Software, Inteligência Artificial e às novas
                                tecnologias aplicadas ao desenvolvimento de sistemas. Sua atuação
                                une a experiência construída ao longo de mais de duas décadas à
                                pesquisa e adoção contínua de novas tecnologias.
                            </p>
                        </div>
                    </div>
                </section>


                <section className="ns-section ns-section--cta">
                    <div className="ns-cta-panel">
                        <div>
                            <span className="ns-kicker">Pronto para conversar?</span>
                            <h2>Se a sua empresa precisa de software profissional, a Nortesoft pode construir a solução certa.</h2>
                        </div>

                        <div className="ns-cta-panel__actions">
                            <Link to="/provisionamento" className="ns-btn ns-btn--primary">
                                Solicitar atendimento
                            </Link>
                            <Link to="/login" className="ns-btn ns-btn--secondary">
                                Ver plataformas
                            </Link>
                        </div>
                    </div>
                </section>
            </main>

            <Footer />
            <FloatingContactButton />
        </div>
    );
};

export default Home;
